import api from './api';

const TOKEN_KEY = 'customer_token';
const USER_KEY  = 'customer_user';

export function getCustomerToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

export function getCustomerUser() {
  try {
    const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function isCustomerLoggedIn() {
  return !!getCustomerToken();
}

export function saveCustomerSession(token, user, remember = false) {
  const storage = remember ? localStorage : sessionStorage;
  storage.setItem(TOKEN_KEY, token);
  storage.setItem(USER_KEY, JSON.stringify(user));
}

export function logoutCustomer() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
}

export function customerApiHeaders() {
  const token = getCustomerToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// Axios instance methods that attach customer token
export async function customerGet(path, params) {
  return api.get(path, { params, headers: customerApiHeaders() });
}

export async function customerPost(path, data, extraConfig = {}) {
  const config = { ...extraConfig, headers: { ...customerApiHeaders(), ...(extraConfig.headers || {}) } };
  return api.post(path, data, config);
}

export async function customerPut(path, data) {
  return api.put(path, data, { headers: customerApiHeaders() });
}

export async function customerDelete(path) {
  return api.delete(path, { headers: customerApiHeaders() });
}
